import { Record, List, Map, fromJS } from 'immutable'

export function parseCsvImport(data) {
  const { columnNames, sampleData, ...rest } = data
  return CsvImport({
    columnNames: List(columnNames),
    sampleData: fromJS(sampleData),
    ...rest,
  })
}

export const CsvImport = Record({
  attributeMapping: undefined,
  columnNames: List(),
  createdAt: undefined,
  id: undefined,
  orgId: undefined,
  sampleData: Map(),
  status: undefined,
  statusData: undefined,
})



// WEBPACK FOOTER //
// ./src/scripts/app/modules/csv/models.js